<template>
    <b-dropdown class="btn-selector" text="Left align" size="sm" no-caret>
        <template #button-content>
            <div class="btn-selector-content">
                <slot />
                <i class="fa-solid fa-chevron-down fa-xs" />
            </div>
        </template>

        <slot name="menu">
            <b-dropdown-item size="xs" v-if="block" @click="block.toggleHidden()">
                <span>{{ block.isHiddenAll ? 'Show' : 'Hide' }} Block</span>
            </b-dropdown-item>
        </slot>
    </b-dropdown>
</template>

<script>
export default {
    name: `btn-selector`,
    props: {
        block: { type: Object, default: null }
    }
}
</script>

<style lang="scss">
.btn-selector {
    position: absolute;
    bottom: 100%;
    left: 0;
    z-index: 3;
    display: none;
    padding-bottom: 8px;
    cursor: pointer;

    &:hover {
        .btn-selector-content {
            background-color: rgb(194, 218, 251);
        }
    }

    .btn.dropdown-toggle {
        border: none;
        background: transparent;
        padding: 0;
        box-shadow: none;

        &:hover, &:focus, &:active {
            background: transparent !important;
            border: none;
            box-shadow: none;
        }
    }

    .dropdown-menu {
        border: 1px solid rgb(29 78 216 / 0.2);
        border-radius: 6px;
        box-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1);
        min-width: 100px;
        padding: 2px !important;
        background: #222222;

        .dropdown-item {
            padding: 4px 8px;
            font-size: 12px;
            color: white !important;
            height: auto !important;
            min-width: 150px !important;
            cursor: pointer !important;

            &:hover {
                background-color: #444444;
                color: rgb(29 78 216 / 1);
            }
        }
    }
}

.btn-selector-content {
    display: flex;
    align-items: center;
    gap: 4px;
    width: fit-content;
    background-color: rgb(219 234 254 / 1);
    color: rgb(29 78 216 / 1);
    border: 1px solid rgb(29 78 216 / 0.1);
    padding: 2px 6px;
    border-radius: 6px;
    font-family: monospace;
    font-size: 12px;
    font-weight: 500;
    text-transform: capitalize;
    letter-spacing: 0;
}
</style>
